import script from "./changePasswordDash.vue?vue&type=script&setup=true&lang=js"
export * from "./changePasswordDash.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__